<div class="tooltip-container">
  <app-tooltip *ngFor="let tooltip of tooltipService.components" [title]="tooltip.title" [body]="tooltip.body" [ref]="tooltip.ref" [position]="tooltip.position" [color]="tooltip.color"></app-tooltip>
</div>
